import { useState, useRef } from "react";
import { Upload } from "lucide-react";
import { api, fileUrl, isVideo } from "@/api";

export const ImageUpload = ({ value, onChange, testid, accept = "image/*", kind = "imagem" }) => {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form);
      onChange(data.path);
    } catch {
      alert("Falha no upload. Tente novamente.");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value ? (
        isVideo(value) ? (
          <video src={fileUrl(value)} muted className="w-16 h-16 object-cover border border-white/15" data-testid={`${testid}-preview`} />
        ) : (
          <img src={fileUrl(value)} alt="" className="w-16 h-16 object-cover border border-white/15" data-testid={`${testid}-preview`} />
        )
      ) : (
        <div className="w-16 h-16 border border-dashed border-white/20 flex items-center justify-center text-zinc-600">
          <Upload size={16} />
        </div>
      )}
      <button type="button" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${testid}-button`}
        className="font-mono2 text-[10px] tracking-[0.2em] uppercase border border-white/20 px-4 py-2 hover:border-white transition-colors disabled:opacity-50">
        {busy ? "Enviando…" : value ? `Trocar ${kind}` : `Enviar ${kind}`}
      </button>
      {value && (
        <button type="button" onClick={() => onChange("")} data-testid={`${testid}-remove`}
          className="font-mono2 text-[10px] tracking-[0.2em] uppercase text-zinc-500 hover:text-[#E63946] transition-colors">
          Remover
        </button>
      )}
      <input ref={inputRef} type="file" accept={accept} className="hidden" onChange={handle} data-testid={`${testid}-input`} />
    </div>
  );
};
